export function getDataZoomOptions(start = 0, end = 40) {
  return [
    {
      type: "slider",
      bottom: 10,
      start: start,
      end: end,
      maxSpan: end,
      minSpan: end,
      height: 10,
      fillerColor: "rgba(144, 147, 153, 0.3)",
      backgroundColor: null,
      cursor: "pointer",
      dataBackground: {
        lineStyle: {
          color: null,
          opacity: 0,
        },
        areaStyle: {
          color: null,
          opacity: 0,
        },
      },
      selectedDataBackground: {
        areaStyle: {
          opacity: 0,
        },
        lineStyle: {
          opacity: 0,
        },
      },
      borderColor: "rgba(255, 255, 255, 0)",
      handleStyle: {
        opacity: 0,
      },
      showDetail: false,
      showDataShadow: false,
      zoomLock: true,
      brushSelect: false,
      brushStyle: {
        opacity: 1,
      },
    },
  ];
}

export function xAxisLabelFormatter(length, value, index, max = 5) {
  let len = 10;
  let clientWidth = document.body.clientWidth;
  if (length <= max) {
    if (clientWidth > 1024) {
      len = value.length > 10 ? len : value.length;
    } else {
      len = 6;
    }
  } else {
    if (clientWidth <= 1024) {
      len = 6;
    }
  }
  value =
    value.length > len ? `${value.substring(0, len)}...` : value;
  return `${index % 2 !== 0 && length > max ? "\n" : ""
    }${value}`;
}